module.exports = __webpack_public_path__ + "fontawesome-webfont.25a32416abee198dd821.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.eot?v=4.6.3
// module id = 538
// module chunks = 2